const registerStyles = {
  '.pageContainer': {
    minHeight: '100vh',
    maxWidth: 'none !important',
  },
  '.backgroundContainer': {
    display: 'flex',
    minHeight: '100vh',
    maxWidth: '1440px',
    margin: 'auto',
  },
  '.banner': {
    width: '40% !important',
    display: 'flex',
    flexDirection: 'column',
    background: 'linear-gradient(270deg, #006FCF 0%, #00175A 100%)',
    justifyContent: 'center',
  },
  '.bannerText': {
    paddingTop: '26px',
    color: '#FFFFFF',
    fontFamily: '"Helvetica Neue"',
    fontSize: '16px',
    letterSpacing: '0',
    lineHeight: '22px',
  },
  '.registration': {
    width: '60% !important',
    padding: '100px 35px 60px 35px',
    display: 'flex',
    flexDirection: 'column',
  },
  // Result-page variant: the logo floats at the top and the message is centered
  // in the full column height (matches the Figma), so drop the top-heavy padding.
  '.registrationCenteredColumn': {
    position: 'relative',
    padding: '35px',
  },
  '.registrationLogoFloat': {
    position: 'absolute',
    top: '35px',
    left: '35px',
  },
  // Fills the column and vertically+horizontally centers the single-message page.
  '.registrationCentered': {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  // Soft-elevated card that wraps both sign-up options.
  '.optionCardContainer': {
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
  },
  // Each option inside the single card is a full-height flex column so the CTA
  // button (with margin-top:auto) aligns at the bottom across both columns.
  '.optionColumn': {
    display: 'flex',
    flexDirection: 'column',
  },
  '.optionCardAction': {
    marginTop: 'auto',
  },
  '.optionDivider': {
    border: 'none',
    borderTop: '1px solid #D3D6DB',
    margin: '16px 0',
  },
};

export default registerStyles;
